package io.github.kingsword09.symbolcraft.symbols.icons.mdi

import androidx.compose.ui.graphics.vector.ImageVector
import io.github.kingsword09.symbolcraft.symbols.icons.mdi.icons.KnifeMdi
import io.github.kingsword09.symbolcraft.symbols.icons.mdi.icons.NinjaMdi
import io.github.kingsword09.symbolcraft.symbols.icons.mdi.icons.PistolMdi
import io.github.kingsword09.symbolcraft.symbols.icons.mdi.icons.TankMdi
import io.github.kingsword09.symbolcraft.symbols.icons.mdi.icons.UnicornVariantMdi
import kotlin.collections.List as ____KtList

public object Icons

private var __AllIcons: ____KtList<ImageVector>? = null

public val Icons.AllIcons: ____KtList<ImageVector>
  get() {
    if (__AllIcons != null) {
      return __AllIcons!!
    }
    __AllIcons= listOf(KnifeMdi, NinjaMdi, PistolMdi, TankMdi, UnicornVariantMdi)
    return __AllIcons!!
  }
